import { createContext, useContext, useState } from 'react'

type ProfileAvatarsActionsContextValues = {
  selectedAvatar: string
  isPopupOpen: boolean
  setSelectedAvatar: (avatar: string) => void
  setIsPopupOpen: (isOpen: boolean) => void
}

export const ProfileAvatarsActionsContext =
  createContext<ProfileAvatarsActionsContextValues>({
    selectedAvatar: '',
    isPopupOpen: false,
    setSelectedAvatar: () => {},
    setIsPopupOpen: () => {},
  })

export const useProfileAvatarsActionsContext = () => {
  const context = useContext(ProfileAvatarsActionsContext)

  if (!context) {
    throw new Error(
      'useProfileAvatarsActionsContext must be used within a ProfileAvatarsActionsContext'
    )
  }

  return context
}

export const ProfileAvatarsActionsProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const [selectedAvatar, setSelectedAvatar] = useState('')
  const [isPopupOpen, setIsPopupOpen] = useState(false)

  return (
    <ProfileAvatarsActionsContext.Provider
      value={{ selectedAvatar, setSelectedAvatar, isPopupOpen, setIsPopupOpen }}
    >
      {children}
    </ProfileAvatarsActionsContext.Provider>
  )
}
